<template>
  <div class="width_1920" v-loading="loading">
    <img class="image1" :src="topPic" />
    <div v-if="projectList.length != 0" class="name">
      <div class="w1790"></div>
      <div
        v-if="projectList[0]"
        :class="
          projectList[0].title.length == 4
            ? 'w107'
            : projectList[0].title.length == 5
            ? 'w158'
            : 'w165'
        "
        style="cursor: pointer"
        @click="clickPro(projectList[0].id)"
      >
        <div
          :class="
            projectList[0].status != 1 ? 'normal_text' : 'current_text center'
          "
        >
          {{ projectList[0].title }}
        </div>
      </div>

      <div class="w152"></div>
      <div
        v-if="projectList[1]"
        :class="
          projectList[1].title.length == 4
            ? 'w107'
            : projectList[1].title.length == 5
            ? 'w158'
            : 'w165'
        "
        style="cursor: pointer"
        @click="clickPro(projectList[1].id)"
      >
        <div
          :class="
            projectList[1].status != 1 ? 'normal_text' : 'current_text center'
          "
        >
          {{ projectList[1].title }}
        </div>
      </div>

      <div class="w152"></div>
      <div
        v-if="projectList[2]"
        :class="
          projectList[2].title.length == 4
            ? 'w107'
            : projectList[2].title.length == 5
            ? 'w158'
            : 'w165'
        "
        style="cursor: pointer"
        @click="clickPro(projectList[2].id)"
      >
        <div
          :class="
            projectList[2].status != 1 ? 'normal_text' : 'current_text center'
          "
        >
          {{ projectList[2].title }}
        </div>
      </div>
      <div class="w152"></div>
      <div
        v-if="projectList[3]"
        :class="
          projectList[3].title.length == 4
            ? 'w107'
            : projectList[3].title.length == 5
            ? 'w158'
            : 'w165'
        "
        style="cursor: pointer"
        @click="clickPro(projectList[3].id)"
      >
        <div
          :class="
            projectList[3].status != 1 ? 'normal_text' : 'current_text center'
          "
        >
          {{ projectList[3].title }}
        </div>
      </div>
      <div class="w152"></div>
      <div
        v-if="projectList[4]"
        :class="
          projectList[4].title.length == 4
            ? 'w107'
            : projectList[4].title.length == 5
            ? 'w158'
            : 'w165'
        "
        style="cursor: pointer"
        @click="clickPro(projectList[4].id)"
      >
        <div
          :class="
            projectList[4].status != 1 ? 'normal_text' : 'current_text center'
          "
        >
          {{ projectList[4].title }}
        </div>
      </div>
      <div class="w152"></div>
      <div
        v-if="projectList[5]"
        :class="
          projectList[5].title.length == 4
            ? 'w107'
            : projectList[5].title.length == 5
            ? 'w158'
            : 'w165'
        "
        style="cursor: pointer"
        @click="clickPro(projectList[5].id)"
      >
        <div
          :class="
            projectList[5].status != 1 ? 'normal_text' : 'current_text center'
          "
        >
          {{ projectList[5].title }}
        </div>
      </div>
      <div class="w152"></div>
      <div
        v-if="projectList[6]"
        :class="
          projectList[6].title.length == 4
            ? 'w107'
            : projectList[6].title.length == 5
            ? 'w158'
            : 'w165'
        "
        style="cursor: pointer"
        @click="clickPro(projectList[6].id)"
      >
        <div
          :class="
            projectList[6].status != 1 ? 'normal_text' : 'current_text center'
          "
        >
          {{ projectList[6].title }}
        </div>
      </div>
      <div class="w152"></div>
      <div
        v-if="projectList[7]"
        :class="
          projectList[7].title.length == 4
            ? 'w107'
            : projectList[7].title.length == 5
            ? 'w158'
            : 'w165'
        "
        style="cursor: pointer"
        @click="clickPro(projectList[7].id)"
      >
        <div
          :class="
            projectList[7].status != 1 ? 'normal_text' : 'current_text center'
          "
        >
          {{ projectList[7].title }}
        </div>
      </div>
      <div class="row w133">
        <div class="flex"></div>
        <div class="total_score">总 分</div>
      </div>
      <div class="w34"></div>
      <div class="w60"></div>
    </div>
    <div class="row">
      <div class="column">
        <div v-for="(item, index) in sportslist" :key="index">
          <div :class="index == 0 ? 'pos_b' : 'pos_b1'">
            <div v-if="index == 0" class="black_bg"></div>
            <div v-else class="black_bg3"></div>
            <div class="label">
              <div class="w534">
                <div v-if="index == 0" class="rank_num">{{ item.rank }}</div>
                <div v-else class="rank_num1">{{ item.rank }}</div>
                <div class="row">
                  <img class="image" :src="item.logo" />
                  <div v-if="index == 0" class="column1">
                    <div class="team_text">{{ item.teamName }}</div>
                    <div class="school_text">{{ item.schoolName }}</div>
                  </div>
                  <div v-else class="column1">
                    <div class="team_text1">{{ item.teamName }}</div>
                    <div class="school_text1">{{ item.schoolName }}</div>
                  </div>
                </div>
              </div>

              <div class="color1"></div>
              <div
                v-if="projectList[0]"
                :class="
                  projectList[0].title.length == 4
                    ? 'w107'
                    : projectList[0].title.length == 5
                    ? 'w158'
                    : 'w165'
                "
              >
                <div
                  v-if="index == 0"
                  :class="
                    item.scores[0]
                      ? projectList[0].status != 1
                        ? 'score2 center'
                        : 'score1 center'
                      : 'score3 center'
                  "
                >
                  {{ item.scores[0] ? item.scores[0] : "--" }}
                </div>
                <div v-else class="score4 center">
                  {{ item.scores[0] ? item.scores[0] : "--" }}
                </div>
              </div>

              <div class="w152"></div>
              <div
                v-if="projectList[1]"
                :class="
                  projectList[1].title.length == 4
                    ? 'w107'
                    : projectList[1].title.length == 5
                    ? 'w158'
                    : 'w165'
                "
              >
                <div
                  v-if="index == 0"
                  :class="
                    item.scores[1]
                      ? projectList[1].status != 1
                        ? 'score2 center'
                        : 'score1 center'
                      : 'score3 center'
                  "
                >
                  {{ item.scores[1] ? item.scores[1] : "--" }}
                </div>
                <div v-else class="score4 center">
                  {{ item.scores[1] ? item.scores[1] : "--" }}
                </div>
              </div>
              <div class="w152"></div>
              <div
                v-if="projectList[2]"
                :class="
                  projectList[2].title.length == 4
                    ? 'w107'
                    : projectList[2].title.length == 5
                    ? 'w158'
                    : 'w165'
                "
              >
                <div
                  v-if="index == 0"
                  :class="
                    item.scores[2]
                      ? projectList[2].status != 1
                        ? 'score2 center'
                        : 'score1 center'
                      : 'score3 center'
                  "
                >
                  {{ item.scores[2] ? item.scores[2] : "--" }}
                </div>
                <div v-else class="score4 center">
                  {{ item.scores[2] ? item.scores[2] : "--" }}
                </div>
              </div>
              <div class="w152"></div>
              <div
                v-if="projectList[3]"
                :class="
                  projectList[3].title.length == 4
                    ? 'w107'
                    : projectList[3].title.length == 5
                    ? 'w158'
                    : 'w165'
                "
              >
                <div
                  v-if="index == 0"
                  :class="
                    item.scores[3]
                      ? projectList[3].status != 1
                        ? 'score2 center'
                        : 'score1 center'
                      : 'score3 center'
                  "
                >
                  {{ item.scores[3] ? item.scores[3] : "--" }}
                </div>
                <div v-else class="score4 center">
                  {{ item.scores[3] ? item.scores[3] : "--" }}
                </div>
              </div>
              <div class="w152"></div>
              <div
                v-if="projectList[4]"
                :class="
                  projectList[4].title.length == 4
                    ? 'w107'
                    : projectList[4].title.length == 5
                    ? 'w158'
                    : 'w165'
                "
              >
                <div
                  v-if="index == 0"
                  :class="
                    item.scores[4]
                      ? projectList[4].status != 1
                        ? 'score2 center'
                        : 'score1 center'
                      : 'score3 center'
                  "
                >
                  {{ item.scores[4] ? item.scores[4] : "--" }}
                </div>
                <div v-else class="score4 center">
                  {{ item.scores[4] ? item.scores[4] : "--" }}
                </div>
              </div>
              <div class="w152"></div>
              <div
                v-if="projectList[5]"
                :class="
                  projectList[5].title.length == 4
                    ? 'w107'
                    : projectList[5].title.length == 5
                    ? 'w158'
                    : 'w165'
                "
              >
                <div
                  v-if="index == 0"
                  :class="
                    item.scores[5]
                      ? projectList[5].status != 1
                        ? 'score2 center'
                        : 'score1 center'
                      : 'score3 center'
                  "
                >
                  {{ item.scores[5] ? item.scores[5] : "--" }}
                </div>
                <div v-else class="score4 center">
                  {{ item.scores[5] ? item.scores[5] : "--" }}
                </div>
              </div>
              <div class="w152"></div>
              <div
                v-if="projectList[6]"
                :class="
                  projectList[6].title.length == 4
                    ? 'w107'
                    : projectList[6].title.length == 5
                    ? 'w158'
                    : 'w165'
                "
              >
                <div
                  v-if="index == 0"
                  :class="
                    item.scores[6]
                      ? projectList[6].status != 1
                        ? 'score2 center'
                        : 'score1 center'
                      : 'score3 center'
                  "
                >
                  {{ item.scores[6] ? item.scores[6] : "--" }}
                </div>
                <div v-else class="score4 center">
                  {{ item.scores[6] ? item.scores[6] : "--" }}
                </div>
              </div>
              <div class="w152"></div>
              <div
                v-if="projectList[7]"
                :class="
                  projectList[7].title.length == 4
                    ? 'w107'
                    : projectList[7].title.length == 5
                    ? 'w158'
                    : 'w165'
                "
              >
                <div
                  v-if="index == 0"
                  :class="
                    item.scores[7]
                      ? projectList[7].status != 1
                        ? 'score2 center'
                        : 'score1 center'
                      : 'score3 center'
                  "
                >
                  {{ item.scores[7] ? item.scores[7] : "--" }}
                </div>
                <div v-else class="score4 center">
                  {{ item.scores[7] ? item.scores[7] : "--" }}
                </div>
              </div>
              <div class="row w133">
                <div class="flex"></div>
                <div v-if="index == 0" class="total_score1">
                  {{ item.scores[projectList.length] }}
                </div>
                <div v-else class="total_score2">
                  {{ item.scores[projectList.length] }}
                </div>
              </div>
              <div class="w34"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="w60"></div>
    </div>
    <div class="h50"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      sportslist: [],
      projectList: [],
      timer: null,
      standId: "",
      processId: "",
      topPic: "",
      loading: false,
    };
  },
  mounted() {
    this.standId = this.$route.query.standId;
    this.processId = this.$route.query.processId;
    let that = this;
    this.loading = true;
    that.getRankList();
    this.timer = setInterval(() => {
      setTimeout(() => {
        that.getRankList();
      }, 0);
    }, 5000);
  },
  beforeDestroy() {
    console.log("aaaa");
    clearInterval(this.timer);
  },
  methods: {
    getRankList() {
      var that = this;
      let data = {
        standId: this.standId,
        processId: this.processId,
      };
      that.api.s_sports.getRankList(data).then((res) => {
        if (res.code == 200) {
          this.loading = false;
          this.projectList = res.result.projects;
          this.sportslist = res.result.teamRank;
          this.topPic = res.result.stand.screenPhoto;
        }
      });
    },
    clickPro(id) {
      this.$router.push({
        path: "/sportSingle",
        query: {
          id: id,
          standId: this.standId,
            processId: this.processId,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.display-flex {
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.width_1920 {
  width: 100%;
  height: 1080px;
  background: #15151e;
  display: flex;
  flex-direction: column;
}
.column {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.w137 {
  width: 137px;
}
.w60 {
  width: 60rpx;
}
.image1 {
  width: 100%;
  height: 216px;
}
.name {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 75px;
}
.w1790 {
  width: 555px;
}
.rank_text {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffead1;
  opacity: 0.9;
  display: flex;
  align-items: center;
  justify-content: center;
}

.normal_text {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: normal;
  color: #bfbacd;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.current_text {
  font-size: 28px;
  font-family: Microsoft YaHei;
  font-weight: normal;
  color: #03ffff;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.title_rank {
  margin-right: 30px;
}

.h91 {
  height: 91px;
}
.pos_b {
  position: relative;
  width: 100%;
  height: 100px;
  margin-bottom: 10px;
}
.pos_b1 {
  position: relative;
  width: 100%;
  height: 80px;
  margin-bottom: 10px;
}
.black_bg {
  position: absolute;
  top: 0;
  left: 0;
  background: #202035;
  width: 100%;
  height: 100px;
  border-radius: 0px 10px 10px 0px;
}
.black_bg3 {
  position: absolute;
  top: 0;
  left: 0;
  background: #f5f4f0;
  margin-right: 60px;
  width: 100%;
  height: 80px;
  border-radius: 0px 10px 10px 0px;
}
.label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.w534 {
  width: 530px;
  display: flex;
  align-items: center;
  flex-direction: row;
}
.label1 {
  background: rgba(14, 21, 48, 0.2);
  width: 1644px;
  height: 100px;
  display: flex;
  flex-direction: row;
  margin-left: 46px;
}
.image {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-left: 15px;
}
.column1 {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
}
.w139 {
  width: 139px;
}
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.mrl13 {
  margin-left: 13px;
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.end_l {
  width: 146px;
  margin-right: 30px;
  height: 100%;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  opacity: 0.9;
}
.flex {
  flex: 1;
}
.team_text {
  font-size: 34px;
  font-family: Microsoft YaHei;
  font-weight: normal;
  color: #e9e9e9;
}
.school_text {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #e9e9e9;
  margin-top: 1px;
}
.team_text1 {
  font-size: 34px;
  font-family: Microsoft YaHei;
  font-weight: normal;
  color: #202035;
}
.school_text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #202035;
  margin-top: 1px;
}
.score1 {
  font-size: 40px;
  font-family: FZPSCH;
  font-weight: normal;
  color: #03ffff;
}
.score2 {
  font-size: 40px;
  font-family: FZPSCH;
  font-weight: normal;
  color: #e0e0e0;
}
.score3 {
  font-size: 40px;
  font-family: FZPSCH;
  font-weight: normal;
  color: #e0e0e0;
}
.score4 {
  font-size: 40px;
  font-family: FZPSCH;
  font-weight: normal;
  color: #202035;
}
.w34 {
  width: 34px;
}
.w133 {
  width: 116px;
}
.total_score1 {
  font-size: 40px;
  font-family: FZPSCH;
  font-weight: normal;
  color: #03ffff;
}
.total_score2 {
  font-size: 40px;
  font-family: FZPSCH;
  font-weight: normal;
  color: #202035;
}
.total_score {
  font-size: 28px;
  font-family: FZZDHJW;
  font-weight: normal;
  color: #03ffff;
  margin-top: 6px;
}
.w87 {
  width: 95px;
}
.w152 {
  width: 16px;
}
.w765 {
  width: 187px;
}
.rank_num {
  font-size: 44px;
  font-family: Bungee;
  font-weight: 400;
  color: #ffffff;
  margin-left: 62px;
  width: 30px;
}
.rank_num1 {
  font-size: 44px;
  font-family: Bungee;
  font-weight: 400;
  color: #202035;
  margin-left: 62px;
  width: 30px;
}
.color1 {
  width: 6px;
  height: 60px;
  background: #ed6d34;
}
.color2 {
  width: 6px;
  height: 60px;
  background: #6f9ca7;
}
.color3 {
  width: 6px;
  height: 60px;
  background: #f1c352;
}
.color4 {
  width: 6px;
  height: 60px;
  background: #95be71;
}
.color5 {
  width: 6px;
  height: 60px;
  background: #59b8cc;
}
.color6 {
  width: 6px;
  height: 60px;
  background: #144e89;
}
.color7 {
  width: 6px;
  height: 60px;
  background: #2185b7;
}
.color8 {
  width: 6px;
  height: 60px;
  background: #a7bfa8;
}
.w98 {
  width: 46px;
}
.w107 {
  width: 107px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.w158 {
  width: 136px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.w165 {
  width: 165px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.h50 {
  height: 60px;
}
</style>
